import { Injectable, inject } from '@angular/core';
import { BaseHttpService } from '../base-http/base-http.service';
import { IPaginationFilter } from '../../../data/store/models/filters.model';
import { ICurrentSection, ITrainingStage, ITrainingSearchResult } from './training.type';
import { ITrainingUserPositionGroup } from '../user/user.type';

@Injectable({
  providedIn: 'root',
})
export class TrainingService {
  private _http = inject(BaseHttpService);

  private readonly _trainingUrl = '/training';

  private readonly _sectionsUrl = '/sections';

  private readonly _sectionUrl = '/section';

  private readonly _contentUrl = '/content';

  private readonly _pagedUrl = '/paged';

  private readonly _stageUrl = '/stage';

  public getSections(filters?: IPaginationFilter) {
    return this._http.get<ITrainingUserPositionGroup[]>(
      `${this._trainingUrl}${this._sectionsUrl}`,
      filters,
    );
  }

  public getCurrentSectionInfo(id: number) {
    return this._http.get<ICurrentSection>(`${this._trainingUrl}${this._sectionUrl}/${id}`);
  }

  public getCurrentStage(id: number) {
    return this._http.get<ITrainingStage>(`${this._trainingUrl}${this._stageUrl}/${id}`);
  }

  public getTrainingFilesList(filters?: IPaginationFilter) {
    return this._http.get<ITrainingSearchResult>(
      `${this._trainingUrl}${this._contentUrl}${this._pagedUrl}`,
      filters,
    );
  }
}
